import React from 'react';
import PropTypes from 'prop-types';

import selectionStyles from './SelectionButton.scss';
import Clickable from '../../../components/Clickable';
import QmImage from '../../../components/Image/QmImage';

const SelectionButton = ({ image, text, className, style, onClick }) => (
  <Clickable
    onClick={onClick}
    className={`${selectionStyles.container} ${className}`}
    style={style}
  >
    <div className={selectionStyles.imageContainer}>
      <QmImage
        contain
        src={image}
        width={80}
        height={80}
        canViewPhoto={false}
      />
    </div>
    <h3 className={selectionStyles.text}>{text}</h3>
  </Clickable>
);

SelectionButton.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default SelectionButton;
